<template>
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <h3>View trip</h3>
            </div>
        </div>

        <div v-if="trip.loadError">
            <Feedback :error="trip.loadError"/>
        </div>
        <div v-else>
            <div class="row mt-3 bg-light p-3">
                <div class="col-sm-6">
                    <span>Created date: </span><span><b>{{formatDatetime(trip.currentTrip.createDate)}}</b></span><br/>
                    <span>Completed date: </span><span><b>{{formatDatetime(trip.currentTrip.completeDate)}}</b></span><br/>
                    <span>Status: </span><span><b>{{formatTripStatus(trip.currentTrip.status)}}</b></span>
                </div>
                <div class="col-sm-6">
                    <span>Code: </span><span><b>{{trip.currentTrip.tripCode}}</b></span>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-12">
                    <span>Waypoints:</span>
                    <WayPointsTable v-bind:way-points="trip.currentTrip.wayPoints" />
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <span>Emails:</span>
                    <p v-html="displayEmails()"></p>
                </div>
            </div>

            <div class="row mt-1">
                <div class="col-sm-6">
                    <span>Notes:</span>
                    <p>{{trip.currentTrip.notes}}</p>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-sm-12">
                    <template v-if="!trip.currentTrip.completeDate && !trip.submitting" >
                        <button type="button"
                                v-on:click="complete"
                                class="btn btn-primary"
                        >Complete</button>
                        <button v-on:click="partiallyComplete"
                                class="btn btn-warning ml-2"
                        >Partially Complete</button>
                        <button v-on:click="cancel"
                                class="btn btn-danger ml-2"
                        >Cancel</button>
                    </template>
                    <button v-on:click="$router.go(-1)"
                            class="btn btn-secondary ml-2"
                    >Back</button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {mapState, mapActions} from "vuex";
    import {formatDatetime, formatTripStatus, TRIP_STATUS} from '../../utils/formatters';
    import WayPointsTable from "./WayPointsTable";
    import Feedback from "../commons/feedback";

    export default {
        name: "view_trip",
        components: {Feedback, WayPointsTable},
        computed: {
            ...mapState({
                trip: state => state.trip,
            }),
        },
        methods: {
            ...mapActions([
                "updateTripStatus"
            ]),
            formatDatetime,
            formatTripStatus,
            displayEmails: function() {
                return this.trip.currentTrip.driversEmails?
                    this.trip.currentTrip.driversEmails.map(item => `<b>${item}</b>`).join(" | ")
                    :""
            },
            complete: function () {

                this.$swal({
                    title: "Complete the trip?",
                    type: "warning",
                    showCancelButton: true,
                    showCloseButton:true
                }).then(results => {
                    if(results.value) {
                        this.updateTripStatus({statusCode: TRIP_STATUS.COMPLETED.code, callback: () => {

                                if(!this.trip.error) {
                                    this.$swal('Completed', 'You successfully completed the trip', 'success');
                                }
                                else {
                                    this.$swal('Error', 'Unexpected error occurred, please try again', 'error');
                                }

                            }});
                    }
                })
            },
            partiallyComplete: function () {

                this.$swal({
                    title: "Partially complete the trip?",
                    type: "warning",
                    showCancelButton: true,
                    showCloseButton:true
                }).then(results => {
                    if(results.value) {
                        this.updateTripStatus({statusCode: TRIP_STATUS.PARTIALLY_COMPLETED.code,callback:  () => {

                                if(!this.trip.error) {
                                    this.$swal('Completed', 'You successfully partially completed the trip', 'success');
                                }
                                else {
                                    this.$swal('Error', 'Unexpected error occurred, please try again', 'error');
                                }

                            }});
                    }
                })
            },
            cancel: function () {

                this.$swal({
                    title: "Cancel the trip?",
                    type: "warning",
                    showCancelButton: true,
                    showCloseButton:true
                }).then( results => {
                    if(results.value) {
                        this.updateTripStatus({statusCode: TRIP_STATUS.CANCELLED.code, callback:  () => {

                                if(!this.trip.error) {
                                    this.$swal('Completed', 'You successfully cancelled the trip', 'success');
                                }
                                else {
                                    this.$swal('Error', 'Unexpected error occurred, please try again', 'error');
                                }

                            }});
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
